const communitiesData = [
  {
    id: 'city-informatics',
    title: 'Професійна спільнота вчителів інформатики Дрогобицької ТГ',
    role: 'Голова спільноти, спікер та розробник цифрових рішень',
    period: '2023 – дотепер',
    badge: 'Територіальна громада',
    color: 'from-blue-600 to-indigo-600',
    icon: 'Users',
    description: `Професійна спільнота педагогів інформатичної галузі закладів загальної середньої освіти Дрогобицької міської територіальної громади. Діяльність спрямована на фахову взаємодію, обмін методичним досвідом та підвищення цифрової компетентності вчителів.`,
    activities: [
      'Презентація та поширення авторського досвіду щодо викладання програмування (Python, алгоритмізація) та сучасних веброзробок',
      'Проведення майстер-класів і воркшопів з інтеграції сервісів штучного інтелекту та хмарних технологій у навчальний процес',
      'Обговорення та впровадження нових навчальних програм, методичних рекомендацій МОН України та Професійного стандарту вчителя',
      'Консультування колег щодо впровадження цифрових інструментів формувального та підсумкового оцінювання'
    ]
  },
  {
    id: 'school-methodical',
    title: 'Кафедра вчителів математики, фізики та інформатики Ліцею №2',
    role: 'Член методичного об’єднання, координатор цифрової трансформації',
    period: '2001 – дотепер',
    badge: 'Інституційний рівень',
    color: 'from-emerald-600 to-teal-600',
    icon: 'GraduationCap',
    description: `Внутрішньошкільна фахова спільнота вчителів точних та інформатичних дисциплін Ліцею №2 Дрогобицької міської ради. Осередок педагогічного пошуку, наставництва та міждисциплінарної інтеграції.`,
    activities: [
      'Розробка інтегрованих STEM-уроків та проєктно-орієнтованих навчальних модулів для учнів ліцею',
      'Координація учнівської участі у науковому товаристві «Еврика» та кураторство дослідницьких проєктів учнів',
      'Технічна та методична підтримка колег під час організації дистанційного та змішаного навчання',
      'Участь у засіданнях педагогічної ради, методичних декадах, семінарах-практикумах та круглих столах'
    ]
  },
  {
    id: 'olympiad-jury',
    title: 'Експертні комісії та журі інтелектуальних змагань і МАН',
    role: 'Член журі та оргкомітету, розробник олімпіадних завдань',
    period: 'Щорічно',
    badge: 'Експертна діяльність',
    color: 'from-amber-600 to-orange-600',
    icon: 'Award',
    description: `Експертна робота у складі журі І та ІІ етапів Всеукраїнських учнівських олімпіад з інформатики та інформаційних технологій, а також захисту науково-дослідницьких робіт учнів-членів МАН.`,
    activities: [
      'Перевірка та експертне оцінювання олімпіадних завдань з алгоритмічного програмування та офісних технологій',
      'Рецензування та оцінювання захисту науково-дослідницьких і творчих робіт учнів-членів МАН України',
      'Підготовка та аналіз тренувальних олімпіадних завдань для обдарованої молоді',
      'Надання фахового зворотного зв’язку учасникам змагань для їхнього подальшого академічного розвитку'
    ]
  },
  {
    id: 'national-edtech',
    title: 'Всеукраїнські мережеві педагогічні та IT-спільноти',
    role: 'Учасник фахових форумів, хакатонів та освітніх платформ',
    period: 'Щорічно',
    badge: 'Всеукраїнський рівень',
    color: 'from-purple-600 to-pink-600',
    icon: 'Network',
    description: `Співпраця з провідними українськими освітніми ініціативами, EdTech-розробниками та професійними онлайн-спільнотами викладачів інформатики й програмування.`,
    activities: [
      'Апробація та презентація авторських вебпродуктів (портал «Дрогобич Талант Хаб», анкети самооцінювання, цифрові довідники)',
      'Участь у фахових конференціях, вебінарах та курсах підвищення кваліфікації провідних освітніх хабів',
      'Обмін досвідом створення відкритого освітнього контенту та автоматизації освітніх процесів',
      'Співпраця з ІТ-кластерами та організаціями щодо ранньої профорієнтації учнівської молоді'
    ]
  }
];

export const communityPrinciples = [
  {
    title: 'Взаємопідтримка та відкритість',
    description: 'Готовність ділитися власними напрацюваннями, програмними кодами та цифровими матеріалами з колегами.',
    icon: 'HeartHandshake'
  },
  {
    title: 'Безперервний професійний розвиток',
    description: 'Систематичне оновлення власних знань у сфері Computer Science, вебтехнологій та сучасної дидактики.',
    icon: 'TrendingUp'
  },
  {
    title: 'Інноваційність та цифровізація',
    description: 'Практичне впровадження передових IT-інструментів, ШІ та хмарних сервісів в освітнє середовище громади.',
    icon: 'Sparkles'
  },
  {
    title: 'Допомога учням та громаді',
    description: 'Спрямування професійного потенціалу на розкриття талантів дітей, розвиток критичного мислення та успіх громади.',
    icon: 'Target'
  }
];

export default communitiesData;
